import styled from '@emotion/styled';
import { FC, PropsWithChildren } from 'react';

// Local Typings
export type Anchor =
  | 'bottom'
  | 'bottom-left'
  | 'bottom-right'
  | 'center'
  | 'left'
  | 'right'
  | 'top'
  | 'top-left'
  | 'top-right';

interface Props {
  anchor?: Anchor;
  rotationDegrees: number;
  rotationSpeedInMs?: number;
}

// Local Variables
function getXOrigin(anchor: Anchor) {
  switch (anchor) {
    case 'top-left':
    case 'left':
    case 'bottom-left':
      return '0%';
    case 'top-right':
    case 'right':
    case 'bottom-right':
      return '100%';
    default:
      return '50%';
  }
}
function getYOrigin(anchor: Anchor) {
  switch (anchor) {
    case 'top-left':
    case 'top':
    case 'top-right':
      return '0%';
    case 'left':
    case 'center':
    case 'right':
      return '50%';
    default:
      return '100%';
  }
}
const Wrapper = styled.div<Props>(({
  anchor = 'center',
  rotationSpeedInMs = 300,
  ...props
}) => ({
  position: 'relative',
  transform: `rotate(${props.rotationDegrees}deg)`,
  transformOrigin: `${getXOrigin(anchor)} ${getYOrigin(anchor)}`,
  transition: `${rotationSpeedInMs}ms`,
}));

// Component Definition
const Rotate: FC<PropsWithChildren<Props>> = props => (
  <Wrapper
    anchor={props.anchor}
    rotationDegrees={props.rotationDegrees}
    rotationSpeedInMs={props.rotationSpeedInMs}
  >
    {props.children}
  </Wrapper>
);

export default Rotate;
